import {
  faSortAlphaDown,
  faSortAlphaDownAlt,
} from '@fortawesome/free-solid-svg-icons';
import { paramsFromSearchString, queryForParams } from 'js/utilities/params';

export const reportsFoldersSortOptions = [
  {
    key: 'folderName-asc',
    field: 'name',
    direction: 'asc',
    i18nKey: 'components.MoveReportModal.sortMenu.folderAsc',
    icon: faSortAlphaDown,
  },
  {
    key: 'folderName-desc',
    field: 'name',
    direction: 'desc',
    i18nKey: 'components.MoveReportModal.sortMenu.folderDesc',
    icon: faSortAlphaDownAlt,
  },
];

export const queryForReportsFoldersSearch = (search = '') => {
  const {
    Keyword = '',
    Order = 'name',
    Sort = 'asc',
    Limit = '10',
    Offset = '0',
  } = paramsFromSearchString(search);

  const params = {
    Keyword,
    Order,
    Sort,
    Limit: parseInt(Limit),
    Offset: parseInt(Offset),
  };

  return queryForParams(params);
};
